import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
    overlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(245, 245, 245, 0.8)",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "4px",
        backdropFilter: "blur(1px)",
    },
    overlayText: {
        fontWeight: "500",
        color: "#444",
        backgroundColor: "white",
        padding: "20px 40px",
        borderRadius: "8px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
        border: "1px solid #eee",
        textAlign: "center",
        maxWidth: "80%",
    }
}));

/**
 * DealerRequiredOverlay
 * A reusable overlay to block interaction and inform the user that a dealer selection is required.
 */
export default function DealerRequiredOverlay({ 
    isVisible = true, 
    title = "Dealer Selection Required", 
    message = "Please select a dealer from the dropdown above to continue." 
}) {
    const classes = useStyles();

    if (!isVisible) return null;

    return (
        <div className={classes.overlay}>
            <div className={classes.overlayText}>
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {message}
                </Typography>
            </div>
        </div>
    );
}

DealerRequiredOverlay.propTypes = {
    isVisible: PropTypes.bool,
    title: PropTypes.string,
    message: PropTypes.string,
};
